// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__qRfR2","info":"UpdateTermsInfo_info__24xt2"};